'use client'

import { useEffect, useState } from 'react'

const NARROW_BREAKPOINT = 1024

export function useIsNarrow(): boolean {
  const [isNarrow, setIsNarrow] = useState(false)

  useEffect(() => {
    const check = () => {
      setIsNarrow(window.innerWidth < NARROW_BREAKPOINT)
    }
    check()
    window.addEventListener('resize', check)
    return () => window.removeEventListener('resize', check)
  }, [])

  return isNarrow
}
